import angular from 'angular';
import PickupController from "./pickup.controller";
import PickupGuestDataController from "./pickup-guest-data.controller";
import ProductDetailController from "../product-detail/productdetail.controller";
import AddToCartController from "../product-detail/addtocart.controller";
import PickupPointOfServiceFormController from "./pickup-point-of-service.controller";
import AddToCartService from "../product-detail/addtocart.service";

let pickup = angular
    .module('pickup', [])
    .controller('PickupController', PickupController)
    .controller('PickupGuestDataController', PickupGuestDataController)
    .controller('ProductDetailController', ProductDetailController)
    .controller('AddToCartController', AddToCartController)
    .controller('PickupPointOfServiceFormController', PickupPointOfServiceFormController)
    .service('AddToCartService', AddToCartService);

export default pickup;
